import {
  apiClient,
  type PageEntity,
  type ShipmentCategoryImportJobExEntity
} from '@/libs/api'
import { type ShipmentCategoryImportJobsRequestQuery } from '@/libs/api/types'

export type FetchShipmentCategoryImportJobsQuery = {
  tenantKey: string
  query: ShipmentCategoryImportJobsRequestQuery
}

export type FetchShipmentCategoryImportJobsResponse = {
  data: ShipmentCategoryImportJobExEntity[]
  pagination: PageEntity | null
}

export const fetchShipmentCategoryImportJobs = async (
  { tenantKey, query }: FetchShipmentCategoryImportJobsQuery,
  signal?: AbortSignal
): Promise<FetchShipmentCategoryImportJobsResponse> => {
  const { data, pagination } = await apiClient
    ._tenant(tenantKey)
    .shipment_category_import_jobs.$get({
      query,
      config: {
        signal
      }
    })
  return {
    data,
    pagination
  }
}
